//@ts-nocheck
/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

import { FeatureFlag } from "../FeatureFlag";

export const Gov2GoIntegration: FeatureFlag = {"Id":"Gov2GoIntegration","Label":"Sync pages with Gov2Go","Impact":"Publishing updates Gov2Go. Gov2Go interation appears in publish pane.","Mode":1,"ActiveOn":null,"ActiveUntil":null,"GlobalEnabled":false,"TenantEnabled":null,"UserEnabled":null,"Scope":7};
